import { IconProps } from '@euler/app/components/icons/types';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const PendingIssuesIcon: FC<IconProps> = memo(
  ({ size, width, height, ...props }) => {
    const { rpx } = useResponsiveContext();
    size = size ?? rpx(64);
    return (
      <Svg
        viewBox="0 0 1024 1024"
        width={width ?? size}
        height={height ?? size}
        {...props}
      >
        <Path
          d="M683.915069 557.314675a31.171286 31.171286 0 0 1 10.855672 42.709314 221.626291 221.626291 0 0 1-381.32873 0 31.171286 31.171286 0 1 1 52.525943-33.559533c0.372194 0.542784 0.682357 1.116583 1.008027 1.690383a159.330244 159.330244 0 0 0 274.214266 0 31.186794 31.186794 0 0 1 42.724822-10.855672z"
          fill="#FFFFFF"
        />
        <Path
          d="M638.770983 0H286.89214C129.950144 0 1.543056 128.407088 1.543056 285.349084v453.255308c0 156.941996 128.407088 285.349084 285.349084 285.349084h282.340512c-130.469665-52.727548-222.541269-180.514312-222.541269-329.857338 0-196.3791 159.221687-355.600788 355.631803-355.600787a354.127518 354.127518 0 0 1 221.765864 77.649068V285.349084C924.120067 128.407088 795.712979 0 638.770983 0zM304.21469 734.882447a44.53927 44.53927 0 0 1-44.399697 44.399697h-42.802362a44.53927 44.53927 0 0 1-44.399697-44.399697 44.53927 44.53927 0 0 1 44.399697-44.353172h42.74033a44.53927 44.53927 0 0 1 44.461729 44.353172z m0-246.237649a44.523762 44.523762 0 0 1-44.399697 44.399697h-42.802362a44.523762 44.523762 0 0 1-44.399697-44.399697 44.53927 44.53927 0 0 1 44.399697-44.415205h42.74033a44.53927 44.53927 0 0 1 44.461729 44.415205z m0-246.702893a44.53927 44.53927 0 0 1-44.399697 44.415205h-42.802362a44.53927 44.53927 0 0 1-44.399697-44.415205 44.53927 44.53927 0 0 1 44.399697-44.399697h42.74033a44.53927 44.53927 0 0 1 44.461729 44.399697z m437.421536 0.697865a43.856914 43.856914 0 0 1-43.717341 43.71734H410.677813a43.841405 43.841405 0 0 1-43.71734-43.71734 43.841405 43.841405 0 0 1 43.71734-43.717341H697.856853a43.841405 43.841405 0 0 1 43.686324 43.717341z"
          fill="#2E91FF"
        />
        <Path
          d="M700.710344 372.737241c-177.691837 0-321.7466 144.101287-321.7466 321.7466s144.054763 321.715584 321.7466 321.715584 321.7466-144.039255 321.7466-321.746601-144.054763-321.715584-321.7466-321.715583z m0 553.856368A232.109768 232.109768 0 1 1 932.804604 694.483841a232.109768 232.109768 0 0 1-232.09426 232.109768z"
          fill="#2E91FF"
        />
        <Path
          d="M664.204271 529.787793m35.808208 0l-0.015508 0q35.808208 0 35.808208 35.808209l0 150.397577q0 35.808208-35.808208 35.808208l0.015508 0q-35.808208 0-35.808208-35.808208l0-150.397577q0-35.808208 35.808208-35.808209Z"
          fill="#2E91FF"
        />
        <Path
          d="M667.585037 751.243495m0-35.808208l0 0.015508q0-35.808208 35.808208-35.808208l150.397577 0q35.808208 0 35.808209 35.808208l0-0.015508q0 35.808208-35.808209 35.808208l-150.397577 0q-35.808208 0-35.808208-35.808208Z"
          fill="#2E91FF"
        />
      </Svg>
    );
  },
);
